import React, { useEffect, useState } from "react";
import "../../../style.scss";
import { Select, Modal } from "antd";
import JobInformation from "./invoices/JobInformation";
import Outgoing from "./invoices/Outgoing";
import Incoming from "./invoices/Incoming";
import { useJobProvider } from "../../../Providers/Vendor/Jobs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../Utils/constants";

export default function Invoices() {
  const { id } = useParams()
  const [modalOpen, setModalOpen] = useState(false);
  const [jobInfo, setJobInfo] = useState(false);
  const [jobId, setJobId] = useState("");
  const [activeTab, setActiveTab] = useState(id ? "Incoming" : "Outgoing");
  const navigate = useNavigate()
  const location = useLocation()
  const permissions = useSelector((state) => state.user.permissions);
  const handleChange = (value) => {
    setJobInfo(true);
    setJobId(value);
    navigate(`/dashboard/invoices/jobs/${value}?withInvoice=true`, { state: { from: location } })
    setModalOpen(false);
  };

  const { fetchJobsHavingTimesheet, allJobs } = useJobProvider();
  useEffect(() => {
    fetchJobsHavingTimesheet();
  }, []);

  return (
    <>
      {!jobInfo ? (
        <>
          <div className="flex flex-row items-start justify-between">
            <div className="flex flex-row justify-between mb-8 space-x-2 grow mr-8">
              <div
                onClick={() => {
                  setActiveTab("Outgoing");
                }}
                style={{
                  color: activeTab === "Outgoing" ? "#1EA596" : "#787878",
                  borderColor: activeTab === "Outgoing" ? "#1EA596" : "#787878",
                  borderBottomWidth: "5px",
                }}
                className="cursor-pointer border-b-4 w-[50%] border-solid flex justify-center"
              >
                <span className="mb-4">Outgoing</span>
              </div>
              <div
                onClick={() => {
                  setActiveTab("Incoming");
                }}
                style={{
                  color: activeTab === "Incoming" ? "#1EA596" : "#787878",
                  borderColor: activeTab === "Incoming" ? "#1EA596" : "#787878",
                  borderBottomWidth: "5px",
                }}
                className="cursor-pointer border-b-4 w-[50%] border-solid flex justify-center"
              >
                <span className="mb-4">Incoming</span>
              </div>
            </div>
            {permissions?.includes(`admin-vendor`) || permissions?.includes(userPermissions.invoices.add) ?
            <button
              onClick={() => {
                setModalOpen(true);
              }}
              className="px-2 py-1 mt-2 text-white"
              style={{
                background: "#139588",
                width: "197px",
                height: "40px",
                borderRadius: "5px",
              }}
            >
              Generate Invoice
            </button>
            : null}
          </div>
          {activeTab === "Outgoing" && <Outgoing />}
          {activeTab === "Incoming" && <Incoming id={id} />}
          <Modal
            title="Select Job"
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            open={modalOpen}
            onOk={() => setModalOpen(false)}
            onCancel={() => setModalOpen(false)}
          >
            <Select
              defaultValue="Select Jobs"
              style={{
                width: 420,
              }}
              onChange={handleChange}
              options={allJobs.map((item) => {
                return { value: item.id, label: item.name };
              })}
            />
          </Modal>
        </>
      ) : (
        <JobInformation
          setJobInfo={setJobInfo}
          jobId={jobId}
          withInvoice={true}
        />
      )}
    </>
  );
}
